module.exports = __webpack_public_path__ + "img/case2.c54b31dd.png";